import React from 'react';
export function Footer() {
  return <footer className="bg-[#050508] py-12 border-t border-white/5 pt-[20px] pb-[20px]" data-id="element-42">
      <div className="container mx-auto px-6 text-center" data-id="element-43">
        <div className="mb-8" data-id="element-44">
          <h3 className="font-serif text-2xl text-white mb-2" data-id="element-45">
            Guía Bienes Raíces
          </h3>
          <p className="text-gold text-sm tracking-widest uppercase" data-id="element-46">
            Para la comunidad latina
          </p>
        </div>

        <p className="text-muted/60 text-sm max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-47">
          Descargo de responsabilidad: Esta guía es un recurso estrictamente
          educativo. No somos agentes inmobiliarios, prestamistas ni asesores
          financieros. La información proporcionada no constituye asesoramiento
          legal o financiero. Te recomendamos consultar con profesionales
          licenciados en tu estado antes de tomar decisiones financieras
          importantes.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-muted/40" data-id="element-48">
          <p data-id="element-49">
            &copy; {new Date().getFullYear()} Guía Bienes Raíces. Todos los
            derechos reservados.
          </p>
          <div className="hidden md:block w-1 h-1 rounded-full bg-muted/40" data-id="element-50" />
          <div className="flex gap-4" data-id="element-51">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-52">
              Términos de Servicio
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-53">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}